export class BasicProjectInformation {
    public id: string;
    public name: string | null = '';

    constructor();
    constructor(projectId: string, projectName: string | null);
    constructor(projectId?: string, projectName?: string | null) {
        if (projectId !== undefined) {
            this.id = projectId;
            this.name = projectName;
        }
    }
}